const request = {
    invalid_input: '輸入無效。{{details}}',
    general: '發生請求錯誤。',
};
export default Object.freeze(request);
